<!--
 * @Author: DESKTOP-6JOF46S\蔡洋杰 1760178806@qq.com
 * @Date: 2023-07-03 09:43:31
 * @LastEditors: DESKTOP-6JOF46S\蔡洋杰 1760178806@qq.com
 * @LastEditTime: 2023-07-05 10:14:35
 * @FilePath: \合联\oms\src\view\operation_modules\dataBoard\index.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template></template>

<script>
export default {
  name: "dataBoard",
  mounted() {
    console.log("chufa111");
    document.getElementsByClassName("content-wrapper")[0].style.padding = "0";
    document.getElementsByClassName("content-wrapper")[0].style.marginTop =
      "0px";
    document.getElementsByClassName("content-wrapper")[0].style.overflow =
      "hidden";
  },
  destroyed() {
    console.log("销毁");
    document.getElementsByClassName("content-wrapper")[0].style.padding =
      "18px";
    document.getElementsByClassName("content-wrapper")[0].style.marginTop = "0";
    document.getElementsByClassName("content-wrapper")[0].style.overflow =
      "auto";
  },
};
</script>

<style >
.content-wrapper {
  padding: 0;
}
</style>